








import { Typography } from '@front/ui'

const appearances = [
  'primary',
  'secondary',
  'tertiary',
  'blackFriday',
  'christmas',
  'saintvalentin',
]
const appearancesValidator = (value) => appearances.includes(value)

export default {
  components: { Typography },
  props: {
    appearance: {
      type: String,
      default: 'primary',
      validator: appearancesValidator,
    },
  },
}
